<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="t_name" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right" @click="historyVisible=true">Chat record</mt-button>
            </mt-header>
        </div>
        <div class="dstouch-chat-con" id="dstouch-chat-con">
            <div v-for="(item,index) in msg_list">

                <chat-message :item="getMessage(item,index,0)" :t_id="t_id"></chat-message>
            </div>
        </div>
        <div class="dstouch-chat-bottom">
            <div class="chat-input-layout"> <span class="open-smile"><a class="iconfont" @click="open_smile">&#xe6cd;</a></span>
                <div class="input-box">
                    <input type="text" v-model="msg" @blur.prevent="inputLoseFocus">
                    <mt-button class="submit" size="small" type="danger" @click="submit()">Send</mt-button>
                </div>
            </div>
            <div class="chat-smile-layout" v-show="smile_show">
                <ul>
                    <li v-for="(smile,index) in smilies_array" @click="addSmile(index)"><img :title="smile.text" :alt="smile.text" :src="getSmile(smile.image)"></li>
                </ul>
            </div>
        </div>

        <!--聊天记录-->
        <mt-popup v-model="historyVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Chat record" class="common-header">
                    <mt-button slot="left" icon="back" @click="historyVisible=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div v-if="historyList && historyList.length">
                        <chat-message v-for="(item,index) in historyList" :key="item.instant_message_id" :item="getMessage(item,index,1)" :t_id="t_id"></chat-message>
                    </div>
                    <empty-record v-else-if="historyList && !historyList.length"></empty-record>
                </div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import ChatMessage from './ChatMessage'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import { addInstantMessage, getChatHistory, joinChat, setMessage } from '../../../api/memberInstantMessage'
var ws
export default {
  data () {
    return {
      params: { 'page': 0, 'per_page': 20 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      historyVisible: false,
      historyList: false,
      t_id: this.$route.query.t_id,
      t_name: this.$route.query.t_name,
      goods_id: this.$route.query.goods_id,
      smile_show: false,
      socket_connect: 0,
      msg_list: [],
      msg: '',
      lockReconnect: false,
      timeOut: false,
      smilies_array: {
        ':smile:': { image: 'smile.gif', text: 'Smile' },
        ':sad:': { image: 'sad.gif', text: 'Sad' },
        ':biggrin:': { image: 'biggrin.gif', text: 'Babble' },
        ':cry:': { image: 'cry.gif', text: 'Cry' },
        ':huffy:': { image: 'huffy.gif', text: 'Angry' },
        ':shocked:': { image: 'shocked.gif', text: 'Surprised' },
        ':tongue:': { image: 'tongue.gif', text: 'Naughty' },
        ':shy:': { image: 'shy.gif', text: 'Shy' },
        ':titter:': { image: 'titter.gif', text: 'Titter' },
        ':sweat:': { image: 'sweat.gif', text: 'Sweat' },
        ':mad:': { image: 'mad.gif', text: 'Mad' },
        ':lol:': { image: 'lol.gif', text: 'Insidious' },
        ':loveliness:': { image: 'loveliness.gif', text: 'Lovely' },
        ':funk:': { image: 'funk.gif', text: 'Panic' },
        ':curse:': { image: 'curse.gif', text: 'Curse' },
        ':dizzy:': { image: 'dizzy.gif', text: 'Gosh' },
        ':shutup:': { image: 'shutup.gif', text: 'Shut up' },
        ':sleepy:': { image: 'sleepy.gif', text: 'Sleep' },
        ':hug:': { image: 'hug.gif', text: 'Embrace' },
        ':victory:': { image: 'victory.gif', text: 'Victory' },
        ':sun:': { image: 'sun.gif', text: 'Sun' },
        ':moon:': { image: 'moon.gif', text: 'Moon' },
        ':kiss:': { image: 'kiss.gif', text: 'Show love' },
        ':handshake:': { image: 'handshake.gif', text: 'Handshake' }
      }
    }
  },
  beforeDestroy: function () {
    this.socket_connect = 0
  },
  components: {
    ChatMessage: ChatMessage,
    EmptyRecord: EmptyRecord
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      user: state => state.member.info
    })
  },
  updated: function () {
    this.$nextTick(function () {
      var div = document.getElementById('dstouch-chat-con')
      div.scrollTop = div.scrollHeight
    })
  },
  mounted () {
  },
  created () {
    if (!this.t_id) {
      Toast('Parameter error')
      this.$router.go(-1)
    }
    if (this.config.instant_message_open != '1' || !this.config.instant_message_gateway_url) {
      Toast('Live chat is not turned on')
      this.$router.go(-1)
    }
    this.fetchConfig({}).then(
      response => {
        this.createWebSocket()
        if (this.goods_id) {
          this.submit(1)
        }
      },
      error => {
        Toast(error.message)
      }
    )
  },
  watch: {

  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    createWebSocket () {
      try {
        ws = new WebSocket(this.config.instant_message_gateway_url)
        this.init()
      } catch (e) {
        this.reconnect()
      }
    },
    init () {
      ws.onopen = this.wsOpen
      ws.onmessage = this.wsMessage
      ws.onclose = this.wsClose
      ws.onerror = this.wsError
    },
    reconnect () {
      if (this.lockReconnect) {
        return
      };
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      this.timeOut && clearTimeout(this.timeOut)
      var _this = this
      this.timeOut = setTimeout(function () {
        _this.createWebSocket()
        _this.lockReconnect = false
      }, 4000)
    },
    wsOpen () {
      this.socket_connect = 1
      // 心跳检测重置
      heartCheck.start()
    },
    wsMessage (res) {
      var message = JSON.parse(res.data)
      if (!message) {
        Toast('Message conversion failed:' + res.data)
        return
      }
      var type = message.type || ''
      switch (type) {
        // Events.php中返回的init类型的消息，将client_id发给后台进行uid绑定
        case 'init':
          this.clientId = message.client_id

          joinChat(this.clientId).then(res => {

          }).catch(error => {
            Toast(error.message)
          })
          break
        case 'leave':
          break
        case 'get_msg':// 未读消息
          this.filterMsg(message.msg_list)
          break
        default:
          this.filterMsg([message])
      }
      heartCheck.start()
    },
    wsClose (res) {
      this.socket_connect = 0
      if (res.reason) {
        console.log('Chat system disconnected:' + res.reason)
      }
      this.reconnect()
    },
    wsError (res) {
      Toast(res.errMsg)
      this.reconnect()
    },
    // 解决调起手机软键盘页面被顶到底部再关闭软键盘页面底部留白的问题
    inputLoseFocus () {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100)
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getHistoryList(true)
      }
    },

    getHistoryList () {
      Indicator.open()

      getChatHistory(this.params, this.t_id).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.list
        if (temp) {
          if (!this.historyList) {
            this.historyList = temp
          } else {
            this.historyList = this.historyList.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    getMessage (item, index, type) {
      this.getTime(item, index, type)
      if (type) {
        return this.historyList[index]
      } else {
        return this.msg_list[index]
      }
    },
    getTime (item, index, type) {
      let time = item.instant_message_add_time
      if (type) {
        this.historyList[index]['if_show_time'] = false
        if (index) {
          if (Math.abs(this.historyList[index - 1]['show_time'] - time) > 10) {
            this.historyList[index]['show_time'] = time
            this.historyList[index]['if_show_time'] = true
          } else {
            this.historyList[index]['show_time'] = this.historyList[index - 1]['show_time']
          }
        } else {
          this.historyList[index]['show_time'] = time
          this.historyList[index]['if_show_time'] = true
        }
      } else {
        this.msg_list[index]['if_show_time'] = false
        if (index) {
          if (Math.abs(this.msg_list[index - 1]['show_time'] - time) > 10) {
            this.msg_list[index]['show_time'] = time
            this.msg_list[index]['if_show_time'] = true
          } else {
            this.msg_list[index]['show_time'] = this.msg_list[index - 1]['show_time']
          }
        } else {
          this.msg_list[index]['show_time'] = time
          this.msg_list[index]['if_show_time'] = true
        }
      }
    },
    open_smile () {
      this.smile_show = !this.smile_show
    },
    addSmile (code) {
      this.msg += code
      this.smile_show = false
    },
    submit (type = 0) {
      let msg
      if (type == 0) {
        if (this.msg == '') {
          Toast('Please fill in the content')
          return
        }
        msg = this.msg
      } else {
        msg = this.goods_id
      }

      addInstantMessage({ to_id: this.t_id, message: msg, message_type: type }).then(res => {
        this.msg = ''
        let msg = res.result.instant_message_data
        this.msg_list.push(msg)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getSmile (smile) {
      return env.SITE_URL + '/static/plugins/js/smilies/images/' + smile
    },
    filterMsg (msg_list) {
      let msg_id = false
      for (var k in msg_list) {
        let msg = msg_list[k]
        if (msg.instant_message_to_id != this.user.member_id || msg.instant_message_from_id != this.t_id) {
          continue
        }
        msg_id = msg.instant_message_id
        this.msg_list.push(msg)
      }
      if (msg_id) {
        if (this.socket_connect) {
          setMessage({ max_id: msg_id, f_id: this.t_id })
        }
      }
    }

  }

}
// 心跳检测
var heartCheck = {
  timeout: 3000,
  timeoutObj: null,
  start: function () {
    var self = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.timeoutObj = setInterval(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      ws.send('123456789')
    }, this.timeout)
  }
}
</script>

<style scoped lang="scss">

    .dstouch-chat-con { position: absolute; z-index: auto; max-height: 100%; left: 0; right: 0; bottom: 2rem; overflow-x: hidden;  overflow-y: auto;box-sizing: border-box;padding-top: 4rem;}

    .dstouch-chat-bottom { position: absolute; z-index: auto; left: 0; right: 0; bottom: 0;}
    .chat-input-layout { position: relative; z-index: 1; display: block; height: 2rem; background-color: rgba(255,255,255,0.90)}
    .chat-input-layout .open-smile { display: block; width: 1.5rem; height: 1.5rem; padding: 0.25rem;}
    .chat-input-layout .open-smile a { display: block; width: 1.5rem; height: 1.5rem; font-size:1.5rem;color:#6eb6eb}
    .chat-input-layout .input-box { position: absolute; z-index: 1; top: 0.24rem; right: 0.4rem; bottom: 0.24rem; left: 2rem; background: #F5F5F5; border: solid 0.05rem #EEE; border-radius: 0.2rem;}
    .chat-input-layout .input-box input[type="text"] { background-color: transparent; border: none; width: 100%; height: 100%; padding:.1rem 3rem .1rem .1rem; font-size: 0.6rem;box-sizing:border-box;display: block;}
    .chat-input-layout .input-box .submit { position: absolute; z-index: 1; top: 0; right:0; display: block; height: 1.4rem; }
    .chat-smile-layout { display: block; width: 100%; height: 4.2rem; background-color: #FAFAFA; border-top: solid 0.05rem #DDD;}
    .chat-smile-layout ul { font-size: 0;}
    .chat-smile-layout ul li { display: inline-block; width: 12.5%; height: 1rem; padding: 0.3rem 0 0 0; text-align: center;  vertical-align: middle;}
    .chat-smile-layout ul li img { display: inline-block; height: 100%; vertical-align: middle;}
    .common-popup-content{background:#f7f7f7;overflow-x:hidden}

</style>
